import { useCookies } from 'react-cookie';

import { COOKIE_KEYS } from 'src/utils/cookies';

export const useLocalCookies = () => {
  const [cookies, setCookie] = useCookies([COOKIE_KEYS.AUTH.SESSION]);

  const getSessionValues = () => {
    try {
      const session = decodeURIComponent(cookies[COOKIE_KEYS.AUTH.SESSION] || '');
      const decodedSession = atob(session).split('~');

      return {
        clientId: decodedSession[0],
        refreshToken: decodedSession[1],
      };
    } catch {
      return {
        clientId: '',
        refreshToken: '',
      };
    }
  };

  const removeAuthCookies = () => {
    setCookie(COOKIE_KEYS.AUTH.SESSION, '');
  };

  return {
    cookies,
    getSessionValues,
    removeAuthCookies,
  };
};
